import { LabSchedulingProvider } from 'context/LabSchedulingContext/LabSchedulingProvider'
import LabSchedulingRouter from './LabSchedulingRouter'
import { ChakraProvider, Flex } from '@chakra-ui/react'
import { APIProvider as GoogleMapsProvider } from '@vis.gl/react-google-maps'
import { memo } from 'react'

const LabScheduling = () => {
  return (
    <ChakraProvider>
      <GoogleMapsProvider apiKey={process.env.GOOGLE_MAPS_API_KEY || ''}>
        <LabSchedulingProvider>
          <Flex
            justify="center"
            align="center"
            height="100vh"
            backgroundColor="var(--gray-extra-light)"
            flexDirection="column"
          >
            <LabSchedulingRouter />
          </Flex>
        </LabSchedulingProvider>
      </GoogleMapsProvider>
    </ChakraProvider>
  )
}

export default memo(LabScheduling)
